import { render, staticRenderFns } from "./GlobalNewsList.vue?vue&type=template&id=407c37a3&scoped=true"
import script from "./GlobalNewsList.vue?vue&type=script&lang=js"
export * from "./GlobalNewsList.vue?vue&type=script&lang=js"
import style0 from "./GlobalNewsList.vue?vue&type=style&index=0&id=407c37a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c37a3",
  null
  
)

export default component.exports